'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('systemOwnerReviewControllers.ReviewUniquePermissions')

.factory('reviewUniquePermissionsService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/SystemOwner/Review/API';

    // **** HttpGet

    service.getSystemTypesToReview = function (authLogin) {
        return $http.get(baseUrl + '/BySystemOwner/' + authLogin +
                         '/UniquePermission/SystemType/ToReview', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSystemRolesToReviewBySystemType = function (authLogin, systemTypeId) {
        return $http.get(baseUrl + '/BySystemOwner/' + authLogin +
                         '/UniquePermission/BySystemType/' + systemTypeId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // **** HttpPost

    service.confirmReview = function (authLogin, systemRoleEmployees) {
        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/UniquePermission/Confirm', {
                              systemRoleEmployeeList: systemRoleEmployees
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    // **** HttpDelete

    service.removeUniquePermission = function (authLogin, employeeId, systemRoleId) {
        return $http.delete(baseUrl + '/BySystemOwner/' + authLogin +
                            '/SystemRole/' + systemRoleId +
                            '/UniquePermission/' + employeeId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.cancelRemoveUniquePermission = function (authLogin, employeeId, systemRoleId) {
        return $http.delete(baseUrl + '/BySystemOwner/' + authLogin +
                            '/SystemRole/' + systemRoleId +
                            '/UniquePermission/' + employeeId +
                            '/Cancel', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
